import { FlagType } from '~/flags/flags';
import { getFlag } from '~/flags/useFlag';

/**
 * Lets engineers exercise the Manage Access UI in a deployed environment
 * before `/access/resource`, `/access/bulk`, and `/access/bulk/preview` exist
 * on the real backend (T14). Toggle `FlagType.AclMockFallback` in
 * LaunchDarkly — every access-control request that gets a 404 from the real
 * endpoint then falls back to the same in-memory mock store the local MSW
 * handlers use, instead of breaking the modal. Leave it off everywhere else.
 */
export function isAccessControlMockFallbackEnabled(): boolean {
  return getFlag(FlagType.AclMockFallback);
}
